exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".avatar,.avatar-uploader,.avatar-uploader-trigger{width:150px;height:150px}.avatar-uploader{display:block;border:1px dashed #d9d9d9;border-radius:6px;cursor:pointer}.avatar-uploader-trigger{display:table-cell;vertical-align:middle;font-size:28px;color:#999}.title{text-align:center}@media (max-width:768px){.ant-calendar-picker,.submit-button{width:100%}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/lib/loader.js!./src/UserForm/UserForm.scss
// module id = 592
// module chunks = 0